import 'magnific-popup';
import '../../js/libs/cards';
import {Gallery} from '../gallery/gallery.js';
import { Input } from '../input/input';
const Mustache = require('mustache');

class Popup {

    constructor(elem) {
        if (elem) {
            this.popup = elem;
        } else {
            this.popup = $('[data-popup]');
            this.popupImg = $('[data-popup-img]');
            this.popupInline = $('[data-popup-inline]');
            this.closeInline = $('[data-popup-inline-close]');
            this.cancel = $('[data-popup-cancel]');
            this.initialize();
        }
    }

    initialize() {

        this.popupImg.magnificPopup({
            type:'image',
            image: {
                markup: '<div class="mfp-figure popup--figure mfp-with-anim">'+
                        '<button title="%title%" type="button" class="mfp-close popup__close"></button>'+
                        '<div class="mfp-img"></div>'+
                        '<div class="mfp-bottom-bar">'+
                        '<div class="mfp-title"></div>'+
                        '<div class="mfp-counter"></div>'+
                        '</div>'+
                        '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

                cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

                titleSrc: 'title', // Attribute of the target element that contains caption for the slide.
                // Or the function that should return the title. For example:
                // titleSrc: function(item) {
                //   return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
                // }

                verticalFit: true, // Fits image in area vertically

                tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
            },
            callbacks: {
                beforeOpen: function() {
                    this.st.mainClass = 'mfp-zoom-in';
                }
            }
        });

        this.popupInline.on('click', function(e) {
            let el = $(this);
            let href = el.attr('href');

            $(href).fadeIn(300);
            e.preventDefault();
        });

        this.closeInline.on('click', function(e) {
            let el = $(this);
            let parent = el.parent();

            parent.fadeOut(300);
            e.preventDefault();
        });

        this.cancel.on('click', function(e) {
            $.magnificPopup.close();

            e.preventDefault();
        });

        $(document).on('click', '.popup-close', function () {
            $.magnificPopup.close();
        });

        this.initPopup();
    }

    initPopup() {

        let cardList;
        // Это пример ответа сервера
        let sampleProduct = null;

        let player;
        let done = false;
        let video;
        let videoId;
        let popup = this.popup;

        if (
            this.popup.is('[data-location-city]')
            && window.Cart
            && window.Cart.isActivePersonalAddresses()
        ) {
            return;
        }

        popup.magnificPopup({
            type:'inline',
            midClick: true,
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
                beforeOpen: function() {
                    this.st.mainClass = 'mfp-zoom-in';
                },
                open: function(event) {
                    let id = this.st.el.attr('href');

                    if (id === '#quickview') {
                        let pid = this.st.el.attr('data-pid');
                        let offers = JSON.parse(this.st.el.attr('data-offers'));
                        let form = $(id).find('form');
                        (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                            try {
                                rrApi.groupView(offers);
                            } catch (e) {
                                console.log(e)
                            }
                        })

                        if (process.env.NODE_ENV === 'development') {

                            cardList = eval(window.cards);

                            for (let i = 0; i < cardList.length; i++) {
                                if (cardList[i]['id'] === pid) {
                                    sampleProduct = cardList[i];
                                }
                            }

                            window.sendProductRequest(form, sampleProduct, id);
                            let galleries = [];

                            if ($('[data-gallery]').length > 0) {
                                $('[data-gallery]').each(function(i) {
                                    galleries[i] = new Gallery($(this), i);
                                    galleries[i].init();
                                    galleries[i].makeDynamic();
                                });
                            }

                        }
                        else{ // production
                            form.find('input[name="pid"]').val(pid);
                            sampleProduct = null;

                            window.sendProductRequest(form, sampleProduct, id, true, function(){
                                let galleries = [];
                                if ($('[data-gallery]').length > 0) {
                                    $('[data-gallery]').each(function(i) {
                                        galleries[i] = new Gallery($(this), i);
                                        galleries[i].init();
                                        galleries[i].makeDynamic();
                                    });
                                }
                            });

                        }
                    }

                    if (id === '#quickviewFavorites') {
                        let productId = this.st.el.attr('data-product-id');
                        let offerId = this.st.el.attr('data-offer-id');
                        let favoriteId = this.st.el.closest('[data-favorites-id]').attr('data-favorites-id')

                        let form = $(id).find('form');

                        form.find('input[data-product-id]').val(productId);
                        form.find('input[data-sku-id]').val(offerId);
                        form.find('[data-favorites-id]').data('favorites-id', favoriteId);

                        sampleProduct = null;

                        window.sendProductRequest(
                            form,
                            sampleProduct,
                            id,
                            true,
                            function() {
                                let galleries = [];

                                if ($('[data-gallery]').length) {
                                    $('[data-gallery]').each(function(i) {
                                        galleries[i] = new Gallery($(this), i);
                                        galleries[i].init();
                                        galleries[i].makeDynamic();
                                    });
                                }
                            }
                        );
                    }

					if (id === '#select-date-popup') {
						let deliveryDateList = $('[data-delivery-day-inputs]');
						let currentSelectedDay = $('input[name="ORDER_PROP_date"]').val();

						deliveryDateList.html('');

						if (window.JS_OBJ && window.JS_OBJ.deliveryTime) {
							window.JS_OBJ.deliveryTime.forEach(function (value, index) {
								let checked = (value.date.text === currentSelectedDay) ? 'checked' : '';
								deliveryDateList.append(`
									<div class="popup__inputs-item">
										<label class="radio-delivery">
											<input class="radio-delivery__input" name="day" type="radio" value="${value.date.value}" ${checked}>
											<div class="radio-delivery__text">${value.date.text}</div>
										</label>
									</div>
								`);
							});
						}
					}

					if (id === '#select-time-popup') {
						let deliveryTimeList = $('[data-delivery-time-inputs]');
						let currentSelectedTime = $('input[name="ORDER_PROP_time"]').val();

						if (window.JS_OBJ && window.JS_OBJ.deliveryTime) {
							let dateIndex = 0;
							let isDateChecked = false;
							$('#select-date-popup').find('input').each(function() {
								if ($(this).is(':checked')) {
									isDateChecked = true;
									return false;
								}
								dateIndex++;
							});

							deliveryTimeList.html('');
							if (isDateChecked) {
								$('#select-time-popup').find('.popup__title').text('Выберите время доставки');

								if (window.JS_OBJ && window.JS_OBJ.deliveryTime) {
									window.JS_OBJ.deliveryTime[dateIndex].time.forEach(function (item, index) {
										let checked = (item.text === currentSelectedTime) ? 'checked' : '';
										deliveryTimeList.append(`
											<div class="popup__inputs-item">
												<label class="radio-delivery">
													<input class="radio-delivery__input" name="day" type="radio" value="${item.value}" ${checked}>
													<div class="radio-delivery__text">${item.text}</div>
												</label>
											</div>
										`);
									});
								}
							}
							else {
								$('#select-time-popup').find('.popup__title').text('Выберите дату доставки');
							}
						}
					}

                    if (id === '#popup-video') {
                        video = this.st.el.attr('data-video');
                        videoId = $(id).find('[data-popup-video]').attr('id');

                        loadPlayer(event);
                    }

                    if (id === '#delete-adress') {
                        let wrap = $(this.st.el).closest('[data-adress-wrap]');
                        let city = wrap.find('[data-adress-city]');
                        let text = wrap.find('[data-adress-text]');

                        $(id).find('[data-address-id]').val(wrap.data('address-id'));
                        $(id).find('[data-popup-adress-city]').text(city.text());
                        $(id).find('[data-popup-adress-text]').text(text.text());
                    }

                    if (id === '#edit-adress') {
                        let wrap = $(this.st.el).closest('[data-adress-wrap]');

                        let addressId = wrap.data('address-id');
                        let locationId = wrap.find('[data-adress-city]').data('location-id');
                        let city = wrap.find('[data-adress-city]').text();
                        let street = wrap.find('[data-address-street]').text();
                        let house = wrap.find('[data-address-building]').text();
                        let flat = wrap.find('[data-address-flat]').text();
                        let isMain = (wrap.find('[data-address-main]').length > 0);

                        $(id).find('[data-address-id]').val(addressId);
                        $(id).find('[data-location-id]').val(locationId);
                        $(id).find('[data-find-city]').val(city);
                        $(id).find('[data-adress-street]').val(street);
                        $(id).find('[data-adress-house]').val(house);
                        $(id).find('[data-adress-flat]').val(flat);

                        $(id).find('input[name="main_address"]').prop('checked', false);
                        if (isMain) {
                            $(id).find('input[name="main_address"]').prop('checked', true);
                        }
                    }

                    if (id === '#add-adress') {
                        $(id).find('input[type="text"]').val('');
                        $(id).find('[data-location-id]').val('');
                        $(id).find('input[name="main_address"]').prop('checked', false);
                    }
                },
                change: function() {
                    if (this.content.data('input-init') === '') {
                        setTimeout(() => {
                            new Input();
                        }, 10);
                    }
                },
                close: function() {
                    if (player) {
                        player.stopVideo();
                        player.destroy();
                        player = undefined;
                    }

                    if ($(this.content).attr('id') === 'city') {
                        if (
                            (window.needReload === 'Y')
                            && window.Cart
                        ) {
                            window.needReload = 'N';

                            window.Cart.refreshCartForm();
                        }
                    }

					if ($(this.content).attr('id') === 'select-date-popup') {
						let dateInputs = jQuery.makeArray($(this.content).find('.radio-delivery__input'));
						$.each(dateInputs,function (index, item){
							if(item.checked) {
								let dateText = item.nextElementSibling.innerText;
								let dateInput = $('[data-input-day]')[0];
								$('[data-delivery-day]').val($(item).val());
								if($(dateInput).hasClass('invalid')) {
									$(dateInput).removeClass('invalid');
									$(dateInput).siblings('label.invalid').hide();
									$(dateInput).parents('[data-input-wrap]').find('label.label-invalid').removeClass('label-invalid');
								}
								dateInput.value = dateText
							}
						})
					}

					if ($(this.content).attr('id') === 'select-time-popup') {
						let timeInputs = jQuery.makeArray($(this.content).find('.radio-delivery__input'));
						$.each(timeInputs,function (index, item){
							if(item.checked) {
								let dateText = item.nextElementSibling.innerText;
								let dateInput = $('[data-input-time]')[0];
								$('[data-delivery-time]').val($(item).val());
								if($(dateInput).hasClass('invalid')) {
									$(dateInput).removeClass('invalid');
									$(dateInput).siblings('label.invalid').hide();
									$(dateInput).parents('[data-input-wrap]').find('label.label-invalid').removeClass('label-invalid');
								}
								dateInput.value = dateText
							}
						})
					}

										if ($(this.content).attr('id') === 'popup-cart-error') {
											$("form[name='ORDER_FORM']").submit();
										}

                    // очищаем данные формы быстрого просмотра
                    if ($(this.content).attr('id') === 'quickview') {
                        // кроме данных пользователя: select (размер, длина, кличество)
                        clearPopupForm(this.content, ['select']);
                    }
                }
            }
        });

        function loadPlayer() {
            if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                window.onYouTubePlayerAPIReady = function () {
                    onYouTubePlayer();
                };
            } else {
                onYouTubePlayer();
            }
        }

        function onYouTubePlayer() {
            player = new YT.Player(videoId, {
                height: '100%',
                width: '100%',
                videoId: video,
                events: {
                },
                playerVars: {
                      playsinline: 1
                }
            });

            onPlayerReady();
        }

        function onPlayerReady() {
            if(player) {

                setTimeout(function() {
                    if (window.onYouTubePlayerAPIReady) {
                        player.playVideo();
                    }
                }, 1000);
            }
        }
    }

    message(title, text) {
        $.magnificPopup.open({
            items: {
              src: `
                  <div class="popup popup--sm mfp-with-anim" id="popup-message">
                      <div class="popup__title">${title}</div>
                    <div class="popup__content">${text}</div>
                </div>`,
              type: 'inline'
            }
        });
    }

    open(data) {
        let src = '#' + this.popup.attr('id');
        const callbacks = {};
        if (data) {
            src = Mustache.render(this.popup.html(), data);
            callbacks.open = function() {
                if ($(src).data('input-init') === '') new Input();
            };
        }
        $.magnificPopup.open({
            items: {
                src
            },
            type: 'inline',
            removalDelay: 500,
            callbacks
        });
    }

    errorMessage() {
        $.magnificPopup.open({
            items: {
                src: `
                  <div class="popup popup--sm mfp-with-anim" id="popup-message">
                      <div class="popup__title">Ошибка</div>
                    <div class="popup__content">
                        При выполнении операции произошла ошибка.<br>
                        Пожалуйста, повторите попытку позже.
                    </div>
                </div>`,
                type: 'inline'
            }
        });
    }
}

/**
 * очищаем данные формы попапа
 * @param content - контент попапа
 * @param exclude - исключения
 */
function clearPopupForm(content, exclude = []){
    if(!!content){
        let ex = '';
        if(exclude.length > 0){
            for(let i in exclude){
                ex += ex? ', ': ''+exclude[i];
            }
        }
        $(content).find(':input')
            .not(ex)
            .val('')
            .prop('checked', false)
            .prop('selected', false);
    }
}

window.Popup = new Popup();

export {Popup};

$(document).ready(function() {
    let defaultText, altText;
    let popup = [];

    $(document).on('click', '[data-caption-trigger]', function() {
        if (!$(this).closest('.p-about').hasClass('opened')) {
            defaultText = $(this).text();
            altText = $(this).data('caption-trigger');
            $(this).closest('.p-about').addClass('opened');
            $(this).text(altText)
        } else {
            $(this).closest('.p-about').removeClass('opened');
            $(this).text(defaultText);
        }
    });

    if ($('[data-popup]').length > 0) {
        let _popup = new Popup();
    }

    // Пример вызова popup с сообщением
    // let popupMessage = new Popup();
    // popupMessage.message('Заголовок', 'Текст');
});
